import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { NavLink } from 'react-router-dom';
import { findIcon } from '../../../utils/iconFinder';

function DrawerItem({
  portalName,
  portalLink,
  setPortalDrawer,
  portalWidgetImage,
}: {
  portalName: string;
  portalLink: string;
  setPortalDrawer: () => void;
  portalWidgetImage: string;
}) {
  return (
    <Tooltip title={portalName} placement="right">
      <ListItem sx={{ width: '100%', p: 0 }}>
        <ListItemButton
          component={NavLink}
          to={portalLink}
          onClick={setPortalDrawer}
          sx={{
            lineHeight: 0,
            margin: 0,
            py: 3,
            borderBottom: '1px solid rgba(0,0,0,0.12)',
            borderRadius: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&.active': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
            }
          }}
        >
          {portalWidgetImage ? (
            <Box
              sx={{
                width: '118px',
                height: '80px',
                borderRadius: '14%',
                border: 'solid 1px black',
                overflow: 'hidden',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#fff",
              }}
            >
              <Box
                component="img"
                src={portalWidgetImage}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  objectPosition: "center",
                }}
              />
            </Box>
          ) : (
            <Box sx={{ opacity: 0.8 }}>
              <FontAwesomeIcon icon={findIcon('far', 'window-maximize')} />
            </Box>
          )}
        </ListItemButton>
      </ListItem>
    </Tooltip>
  );
}

export default DrawerItem;
